import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Context }  from '../Auth.Context';
import { canOpen, getLmsAccess, homePath, refreshLmsAccess } from '../components/Lms/lmsAccess';

export default function AdminProtectedRoute() {
	const [adminDetails,] = useContext(Context);
	const location = useLocation();
	const [lmsAccess, setLmsAccess] = useState(getLmsAccess);
	const loggedIn = Boolean(adminDetails && adminDetails._id);

	// cached access shows the screen right away, then the latest from the API (role / sections may have changed)
	useEffect(() => {
		if (!loggedIn) return;
		refreshLmsAccess().then(setLmsAccess).catch(() => {});
	}, [loggedIn]);

  // console.log("AdminProtectedRoute - adminDetails:", adminDetails);
	if(!loggedIn){
		return <Navigate to="/login" />;
		// return <Outlet />;
	}
	// a sub admin only gets the LMS sections their role has
	if(!canOpen(location.pathname, lmsAccess)){
		return <Navigate to={homePath(lmsAccess)} replace />;
	}
	return <Outlet />;
}// end AdminProtectedRoute()
